
<template>
  <div class="widgets-container">
    <div class="toolbar-container">
      <v-col no-gutters>
        <!-- Top row: first switch -->
        <v-row class="mb-2">
          <v-switch
            v-model="showWeatherTiles"
            color="white"
            @change="onSwitchChanged(showWeatherTiles, selectedOption)"
          >
            <template v-slot:label>
              <span class="custom-switch-label">Show weather tiles</span>
            </template>
          </v-switch>
        </v-row>

        <div
          v-if="showWeatherTiles"
          class="toolbar-dropdown"
        >
          <v-menu
            :rounded="rounded"
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="transparent"
                class="white--text"
                v-bind="attrs"
                :flat="true"
                v-on="on"
              >
                {{ selectedOption }}
                <v-icon
                  right
                  dark
                  small
                >
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="item in items"
                :key="item"
                link
                @click="selectOption(item)"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-dialog
          v-if="showWeatherTiles"
          ref="dateDialog"
          v-model="dateModal"
          persistent
          width="290px"
          :return-value.sync="dateModel"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              color="transparent"
              class="white--text"
              :flat="true"
              v-on="on"
            >
              <v-icon
                dark
                small
              >
                mdi-calendar
              </v-icon>
            </v-btn>
          </template>
          <v-date-picker
            v-model="dateModel"
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dateModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dateDialog.save(dateModel)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>

        <v-dialog
          v-if="showWeatherTiles"
          ref="timeDialog"
          v-model="timeModal"
          :return-value.sync="timeModel"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="transparent"
              class="white--text"
              :flat="true"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                dark
                small
              >
                mdi-clock
              </v-icon>
            </v-btn>
          </template>
          <v-time-picker
            v-if="timeModal"
            v-model="timeModel"
            full-width
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="timeModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.timeDialog.save(timeModel)"
            >
              OK
            </v-btn>
          </v-time-picker>
        </v-dialog>

        <v-btn
          v-if="showWeatherTiles"
          color="transparent"
          class="white--text"
          :loading="renderingIsLoading"
          :flat="true"
          @click="onReloadButtonPressed(selectedOption)"
        >
          <v-icon
            dark
            small
          >
            mdi-reload
          </v-icon>
        </v-btn>

        <v-row
          v-if="showWeatherTiles"
          class="mt-5"
        >
          Selected datetime : {{ dateModel }} at {{ timeModel }}
        </v-row>
      </v-col>
      <SolutionsChartComponent v-if="showDiagram" />
    </div>
    <ContourBarsComponent
      v-show="showWeatherTiles"
      :option="selectedOption"
      class="contour-widget-position"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ContourBarsComponent from "./ContourBarsComponent.vue";
import { MeteoOptions } from "../../../../domain/weather_routing/meteo_options/enum";
import SolutionsChartComponent from "./SolutionsChartComponent.vue";
export default {
  components: {
    ContourBarsComponent,
    SolutionsChartComponent,
  },
  props: {
    onMeteoSelected: Function,
    onReloadButtonPressed: Function,
    onSwitchChanged: Function,
    showDiagram: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedOption: MeteoOptions.Wind,
      colors: ["deep-purple accent-4"],
      items: [MeteoOptions.Wind, MeteoOptions.Currents, MeteoOptions.Waves],
      showWeatherTiles: false,
      dateModal: false,
      timeModal: false,
      showWFleet: false,
      fleetDialog: false,
    };
  },
  computed: {
    ...mapState("weatherRouting/tilesModule", [
      "renderingIsLoading",
      "selectedDate",
      "selectedTime",
    ]),
    ...mapState("weatherRouting/voyageDetailsModule", ["voyageSolutions"]),
    dateModel: {
      get() {
        return this.selectedDate;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/tilesModule/SET_SELECTED_DATE",
          value,
          { root: true }
        );
      },
    },
    timeModel: {
      get() {
        return this.selectedTime;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/tilesModule/SET_SELECTED_TIME",
          value,
          { root: true }
        );
      },
    },
  },
  methods: {
    ...mapActions("weatherRouting/tilesModule", [
      "fetchWeatherTiles",
      "loadOceanCurrentTiles",
      "removeCurrentLayer",
    ]),
    selectOption(item) {
      this.selectedOption = item;
      this.onMeteoSelected(this.selectedOption);
    },
    onFleetSwitchChanged(value) {
      if (value) {
        this.fleetDialog = true; // open popup when switch ON
      } else {
        this.fleetDialog = false; // close if switched OFF
      }
    },

  },
  watch: {
    voyageSolutions: {
      handler(newValue) {
        if (newValue != null && newValue.routes.length != 0) {
          this.dateModel = newValue.routes[1].data[0].date;
          this.timeModel = newValue.routes[1].data[0].time;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.widgets-container {
  display: flex;
  align-items: center;
  border-radius: 5px;
  color: white;
  height: 93%;
  width: 94%;
  pointer-events: none;
}

.contour-widget-position {
  position: absolute;
  bottom: 0;
}

.toolbar-container {
  pointer-events: auto;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  background-color: var(--color-surface);
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 2px 5px #000000;
  color: var(--color-text);
}

.toolbar-button-group {
  display: flex;
}

.custom-switch-label {
  color: var(--color-text); /* Change the label color to red */
  /* Optional: make the label bold */
}

.toolbar-button:last-child {
  margin-left: auto; /* Push the last button to the right */
}
</style>
